// extracted by mini-css-extract-plugin
module.exports = {"content":"WorkType_content__tctlo","submitBtn":"WorkType_submitBtn__2oql0"};